import React from 'react';
import { Instagram, Twitter, Facebook, Mail } from 'lucide-react';
import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Product',
      links: [
        { label: 'Food Feed', href: '/feed' },
        { label: 'Local Favorites', href: '/#best-of-area' },
        { label: 'Supper Club', href: '/supperclub' },
        { label: 'Leaderboard', href: '/leaderboard' },
        { label: 'Mobile App', href: '#' },
      ],
    },
    {
      title: 'Community',
      links: [
        { label: 'Join the Community', href: '/signup' },
        { label: 'Become a Critic', href: '#' },
        { label: 'Host a Supper Club', href: '#' },
        { label: 'Partner Restaurants', href: '#' },
        { label: 'Events', href: '#' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Help Center', href: '#' },
        { label: 'Blog', href: '#' },
        { label: 'Guides', href: '#' },
        { label: 'API Documentation', href: '#' },
        { label: 'Contact Us', href: '#' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About RatedBite', href: '#' },
        { label: 'Careers', href: '#' },
        { label: 'Press Kit', href: '#' },
        { label: 'Investors', href: '#' },
        { label: 'Brand Guidelines', href: '#' },
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="container mx-auto px-8 max-w-7xl">
        {/* Main Footer Content */}
        <div className="py-20">
          <div className="grid grid-cols-12 gap-16">
            {/* Brand & Newsletter Column */}
            <div className="col-span-4">
              <h2 className="serif text-4xl mb-6">RatedBite</h2>
              <p className="text-sm text-muted-foreground leading-relaxed mb-8">
                Discover, rate, and share the finest culinary experiences.
                Join our community of food enthusiasts.
              </p>

              {/* Newsletter */}
              <div className="mb-8">
                <h3 className="text-sm uppercase tracking-widest mb-4">Newsletter</h3>
                <p className="text-xs text-muted-foreground mb-4">
                  Get weekly curated dining recommendations
                </p>
                <div className="flex gap-2">
                  <div className="relative flex-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <input
                      type="email"
                      placeholder="Your email"
                      className="w-full pl-10 pr-4 h-10 border border-border bg-card text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
                    />
                  </div>
                  <button className="px-6 h-10 border border-foreground text-foreground hover:bg-foreground hover:text-background transition-all duration-300 text-xs uppercase tracking-widest whitespace-nowrap">
                    Subscribe
                  </button>
                </div>
              </div>

              {/* Social Links */}
              <div>
                <h3 className="text-sm uppercase tracking-widest mb-4">Follow Us</h3>
                <div className="flex gap-4">
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 border border-border hover:border-foreground flex items-center justify-center transition-colors"
                    aria-label="Instagram"
                  >
                    <Instagram className="w-4 h-4" />
                  </a>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 border border-border hover:border-foreground flex items-center justify-center transition-colors"
                    aria-label="Twitter"
                  >
                    <Twitter className="w-4 h-4" />
                  </a>
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 border border-border hover:border-foreground flex items-center justify-center transition-colors"
                    aria-label="Facebook"
                  >
                    <Facebook className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>

            {/* Links Columns */}
            <div className="col-span-8">
              <div className="grid grid-cols-4 gap-8">
                {footerSections.map((section) => (
                  <div key={section.title}>
                    <h3 className="text-sm uppercase tracking-widest mb-6">
                      {section.title}
                    </h3>
                    <ul className="space-y-3">
                      {section.links.map((link) => (
                        <li key={link.label}>
                          <a
                            href={link.href}
                            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                          >
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border py-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-8">
              <p className="text-xs text-muted-foreground">
                © {currentYear} RatedBite. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <a
                  href="/privacy"
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                >
                  Privacy Policy
                </a>
                <a
                  href="/terms"
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                >
                  Terms of Service
                </a>
                <a
                  href="/cookies"
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                >
                  Cookie Policy
                </a>
                <a
                  href="/accessibility"
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                >
                  Accessibility
                </a>
              </div>
            </div>

            <div className="text-xs text-muted-foreground">
              Made with care for food lovers
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

